
export interface ArrowScreenPoint {
  readonly x: number;
  readonly y: number;
}

type ArrowFallbackContext = Pick<
  CanvasRenderingContext2D,
  "save" | "restore" | "beginPath" | "moveTo" | "lineTo" | "stroke"
> & {
  globalAlpha: number;
  strokeStyle: CanvasRenderingContext2D["strokeStyle"];
  lineWidth: number;
};

/** Draw one readable shaft and arrowhead, with no state left on the caller. */
export function drawArrowFallback(
  ctx: ArrowFallbackContext,
  tail: ArrowScreenPoint,
  head: ArrowScreenPoint,
): void {
  const dx = head.x - tail.x;
  const dy = head.y - tail.y;
  const length = Math.hypot(dx, dy);
  if (!(length > 0)) return;

  const nx = dx / length;
  const ny = dy / length;
  const sideX = -ny;
  const sideY = nx;
  const headLength = Math.min(14, Math.max(6, length * 0.24));
  const headWidth = headLength * 0.55;

  ctx.save();
  ctx.globalAlpha = 0.92;
  ctx.strokeStyle = "#ffe08a";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(tail.x, tail.y);
  ctx.lineTo(head.x, head.y);
  ctx.moveTo(head.x - nx * headLength + sideX * headWidth, head.y - ny * headLength + sideY * headWidth);
  ctx.lineTo(head.x, head.y);
  ctx.lineTo(head.x - nx * headLength - sideX * headWidth, head.y - ny * headLength - sideY * headWidth);
  ctx.stroke();
  ctx.restore();
}
